// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-1DH_j","rootAvtive":"index-rootAvtive-3wgOh","fadeInUp":"index-fadeInUp-1PEF-","fadeInDown":"index-fadeInDown-37hPM","show":"index-show-2r0b6"};